import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Footer from './Footer';
export const Layout = ({ children }) => {
  const location = useLocation();
  const publicRoutes = ['/login', '/register','/','/interactive-demo','/forgot-password'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  return (
    <div style={{ display: 'flex' }}>
      {!isPublicRoute && <Sidebar />}
      <main style={{ 
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'  // Stack children vertically
      }}>
        <div style={{ flexGrow: 1 }}>  {/* Content wrapper */}
          {children}
        </div>
        <Footer />  {/* Footer only on public routes */}
      </main>
    </div>
  );
};